var _line, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditclienttask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 905,
    height: 16,
    viewBox: "0 0 905 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 7,
    x2: 889,
    y2: 7,
    stroke: "#E6E6E6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M705 8L694.6 16L697.6 8L694.6 0L705 8Z",
    fill: "#30537E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M457.7 8L447.3 16L450.3 8L447.3 0L457.7 8Z",
    fill: "#30537E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.4 8L200 16L203 8L200 0L210.4 8Z",
    fill: "#30537E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditclienttask);
export default __webpack_public_path__ + "static/media/editclienttask.7258f0c96fcadd85863fcd5441b93c63.svg";
export { ForwardRef as ReactComponent };